import { rangeFor, type Period } from "./dates";

export const PERIOD_SLUGS: Record<Period, string> = {
  daily: "gunluk",
  weekly: "haftalik",
  monthly: "aylik",
};

export const periodFromSlug = (slug: string | undefined) =>
  (Object.keys(PERIOD_SLUGS) as Period[]).find(p => PERIOD_SLUGS[p] === slug);

// Adres her zaman dönemin başlangıcını gösterir: haftalık → pazartesi, aylık → YYYY-AA
export function reportPath(period: Period, anchorISO: string, search = "") {
  const { from } = rangeFor(period, anchorISO);
  const key = period === "monthly" ? from.slice(0, 7) : from;
  return `/${PERIOD_SLUGS[period]}/${key}${search ? `?${search}` : ""}`;
}

// URL'deki tarih parçasını YYYY-MM-DD'ye çevirir; geçersizse null
export function anchorFromParam(param: string | undefined): string | null {
  if (!param) return null;
  const m = /^(\d{4})-(\d{2})(?:-(\d{2}))?$/.exec(param);
  if (!m) return null;
  const [, y, mo, d = "01"] = m;
  const date = new Date(Number(y), Number(mo) - 1, Number(d));
  const valid = date.getFullYear() === Number(y) && date.getMonth() === Number(mo) - 1 && date.getDate() === Number(d);
  return valid ? `${y}-${mo}-${d}` : null;
}
